import useSWR from 'swr';
import { Constants } from '@CONFIG';
import { axios } from '@LIBS';

const useGET = (url, value = true, method = 'GET', postData = null) => {
  const { data, error, isValidating, mutate } = useSWR(
    value
      ? `${Constants.BACKEND_API_URL}/${url}${value !== true ? value : ''}`
      : null,
    (url) =>
      axios({
        url,
        method,
        data: postData,
      })
        .then((response) => response)
        .catch((error) => error),
    {
      revalidateOnMount: true,
    }
  );

  return {
    data: !isValidating ? data : [],
    loading: isValidating,
    error,
    mutate,
  };
};

export { useGET };
